import './App.css';
import { Suspense } from 'react';
import Routes from './Routings'
import i18n from './i18n';


function App (props) {
  const savedLang = localStorage.getItem('ui.lang');
    if (savedLang && savedLang !== i18n.language) {
      i18n.changeLanguage(savedLang);
    }
  return (
  <>
    <Suspense fallback={              
      <div id="preloader">                
          <div className="sk-three-bounce">
              <div className="sk-child sk-bounce1"></div>
              <div className="sk-child sk-bounce2"></div>
              <div className="sk-child sk-bounce3"></div>
          </div>
      </div>  
      }
    >
    <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1"></meta>
    <Routes/>
                
    </Suspense>
  </>
  );    
};

export default App;
